import type { Language } from "@/screens/settings/settings-pages/language-selector"

interface Translatable {
	title: string
	translations?: readonly { language: string; title?: string | null }[]
}

// The nav only needs the displayed title. Going through useItemTranslations
// would run a `currentWorkspace` Zero query per row just to read a default
// language the nav never uses.
export function translatedTitle(
	item: Translatable,
	selectedLanguage: Language,
) {
	const translated = item.translations?.find(
		(t) => t.language === selectedLanguage.code,
	)?.title
	return translated || item.title
}

export function translatedName(
	item: {
		name: string
		translations?: readonly { language: string; title?: string | null }[]
	},
	selectedLanguage: Language,
) {
	const translated = item.translations?.find(
		(t) => t.language === selectedLanguage.code,
	)?.title
	return translated || item.name
}
